import React from 'react';

export const DragDrop = () => (
    <>
        <rect x='8' y='8' width='12' height='12' rx='2'></rect>
        <line x1='4' y1='4' x2='4' y2='4.01'></line>
        <line x1='8' y1='4' x2='8' y2='4.01'></line>
        <line x1='12' y1='4' x2='12' y2='4.01'></line>
        <line x1='16' y1='4' x2='16' y2='4.01'></line>
        <line x1='4' y1='8' x2='4' y2='8.01'></line>
        <line x1='4' y1='12' x2='4' y2='12.01'></line>
        <line x1='4' y1='16' x2='4' y2='16.01'></line>
    </>
);